import React, { Fragment } from 'react';
import { Button, Table, Segment, Loader, Popup, Header, Tab, Grid } from 'semantic-ui-react';
import axios from 'axios';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import { ToastContainer } from 'react-toastify';
import { fetchSPStatuses, fetchStudyCycle, fetchTitles } from '../../Lookups/util';
import StudentServiceImplStatus from './StudentServiceImplStatus';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const NoDataMessage = () => <p>Nema implementacija odabranog studijskog programa.</p>;


export default class StudentServiceSPImpl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            studyCycles: this.props.location.state ? this.props.location.state.studyCycles : [],
            titles: this.props.location.state ? this.props.location.state.titles : [],
            SPStatuses: [],
            loading: true,
            activeIndex: 2,
        };
        this.getSPImplementations = this.getSPImplementations.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.active = this.active.bind(this);
    }

    componentDidMount() {
        this.active();
        axios.all([fetchStudyCycle(), fetchTitles(), fetchSPStatuses()])
            .then(axios.spread((studyCycleRes, titlesRes, statusesRes) => {
                this.setState({
                    studyCycles: studyCycleRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    })),
                    SPStatuses: statusesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })),
                    titles: titlesRes.data
                }, this.getSPImplementations);
            }));
        localStorage.removeItem('studyProgramDescription');
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
    }

    active() {
        if (localStorage.getItem('archived') === 'false') {
            this.setState({ activeIndex: 0 });
        }
    }


    getSPImplementations() {
        let id = parseInt(localStorage.getItem('studyProgramBasic'), 10);
        axios.get(`study-programs/implementations-for-basic/${id}`)
            .then(res => {
                this.setState({
                    data: res.data,
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch study program implementations');
            });
    }


    render() {
        const { SPStatuses } = this.state;
        let panes = [
            localStorage.getItem('archived') === 'false' && {
                menuItem: 'Aktivne implementacije',
                render: () => (<Tab.Pane as="div" attached={false} responsive={Responsive}>
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            <StudentServiceImplStatus
                                data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'active')}
                                studyCycles={this.state.studyCycles}
                            />
                        </div>
                    }
                </Tab.Pane>)
            },
            localStorage.getItem('archived') === 'false' && {
                menuItem: 'Pasivne implementacije',
                render: () => (<Tab.Pane as="div" attached={false} responsive={Responsive}>
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            <StudentServiceImplStatus
                                data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'pasive')}
                                studyCycles={this.state.studyCycles}
                            /></div>}
                </Tab.Pane>)
            },
            {
                menuItem: 'Arhivirane implementacije',
                render: () => (<Tab.Pane as="div" attached={false} responsive={Responsive}>
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            <StudentServiceImplStatus
                                data={this.state.data.filter(el => el.studyProgram.studyProgramStatus._key === 'archived')}
                                studyCycles={this.state.studyCycles}
                            /></div>}
                </Tab.Pane>)
            }
        ];

        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <h1>Spisak implementacija studijskog programa</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header
                            as="h3"
                            content={localStorage.getItem('studyProgramBasicName')}
                            subheader="Osnovni studijski program"
                        >

                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudentServiceSPImpl.js